import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import { LanguageLocaleEnum } from "../../../client/api";
import { translate } from "../../../config/translator";

type CareerLegendProps = {
  l: LanguageLocaleEnum;
};

const CareerLegend: React.FC<CareerLegendProps> = ({ l }) => (
  <div className="flex flex-row items-center justify-start gap-6 -mt-2 pl-4">
    <div className="flex flex-row items-center gap-2">
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="text-primary dark:text-primary-dark"
        size="lg"
      />
      <span className="text-sm text-font-600 dark:text-font-600-dark">
        {translate("verifiedEntry", l)}
      </span>
    </div>
    <div className="flex flex-row items-center gap-2">
      <FontAwesomeIcon
        icon={faCircleQuestion}
        className="text-font-600 dark:text-font-600-dark"
        size="lg"
      />
      <span className="text-sm text-font-600 dark:text-font-600-dark">
        {translate("createdByPlayer", l)}
      </span>
    </div>
  </div>
);

export default CareerLegend;

